import React from "react";

export function Pencil( props: React.SVGProps<SVGSVGElement> ) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path
                d="M14.3992 5.13818L6.31616 13.2212L1.59937 14.3999L2.77905 9.68311L10.8611 1.6001L14.3992 5.13818ZM3.90796 10.3228L3.31909 12.6812L5.67651 12.0913L10.9919 6.7749L9.22144 5.00732L3.90796 10.3228ZM10.1267 4.10205L11.8962 5.87158L12.6306 5.13818L10.8611 3.36865L10.1267 4.10205Z"
                fill="currentColor"
            />
        </svg>
    );
}
